import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "objectToArray"
})
export class ObjectToArrayPipe implements PipeTransform {
    public transform(value: any, withKey: boolean = false): any {

        if (_.isNil(value)) {
            return [];
        }

        return Object.keys(value).map((key) => {
    
            return withKey ? { ...value[key], key } : value[key];
        });
    }
}



@Pipe({
    name: 'reverse'
  })
  export class ReversePipe implements PipeTransform {
  
    transform(value) {
        if (!value) return;
  
        return value.reverse();
      }
  }